import React, { Component } from 'react'
import { Link } from "react-router-dom";
import { Modal, ModalBody } from "reactstrap";
import Helper from "../../../Configs/Helper"
import Validation from "../../../Configs/Validation";
import SocialBtns from "../../SubComponents/SocialBtns/SocialBtns"
import Loader from "../../SubComponents/Loader/Loader";
import { withAlert } from 'react-alert'
import { generateTokenAction, sendOtpAction, otpVerifyResetPassAction, resetPasswordAction } from "../../../store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginSection: true,
      emailSection: false,
      otpSection: false,
      newPassSection: false,
      email:'',
      emailErrorMsg: '',
      otp:'',
      otpErrorMsg: '',
      passFormErrors: {new_password: '', conf_password: ''},
      passFormValid: false,
    }
}

  closeModal = () => {
    this.props.closeModal('loginModal');
  };
  onChangeHandler = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if(name==='email'){
      this.setState({ [name]: value },()=>{
        const errorMsg = Validation.isEmailValid(this.state.email);
        this.setState({ emailErrorMsg: errorMsg });
      });
    } else if(name==='otp'){
      let errorMsg = '';
      if(value.length<6 || value.length>6){
        errorMsg = Helper.flashMsg('otpLength');
      }
      this.setState({ [name]: value, otpErrorMsg: errorMsg });
    } else if(name==='new_password' || name==='conf_password'){
        this.setState({ [name]: value },()=>{
          const res = Validation.forgotPassForm(name, value,this.state);
          this.setState({ passFormValid:res.formValid, passFormErrors: res.formErrors });
        });
    }
    
  }
  onPressForgotPass = (event) =>{
    this.setState({ loginSection: false, emailSection: true });
  }
  sendOtpHandler = async (event) =>{console.log(this.state);
    if(this.state.email===''){
      this.setState({ emailErrorMsg: Helper.flashMsg('emailReq') });
    } else if(this.state.emailErrorMsg!==''){
      return;
    } else {
      const generateTokenPostData = { client_id: "", client_type: "web", email_id: this.state.email, auth_type: "email" };
      this.loader.show(true);
      await this.props.generateTokenAction(generateTokenPostData);
      if(!this.props.tokenData.error){
          const postData = { email_id: this.state.email, auth_type: 'email', client_id: '', client_type: 'web' };
          
          await this.props.sendOtpAction(postData);
          console.log(this.props, 'OTP_DATA');
          if(this.props.otpData.status===200){
            this.setState({emailSection: false, otpSection: true, otpSessionId: this.props.otpData.data.otp_session_id, emailErrorMsg:''});
            this.loader.showAlert(true,'success',this.props.otpData.message)
          } else {
            this.loader.showAlert(true,'error',this.props.otpData.message)
          }       
      }
      this.loader.show(false);
    }
  }
  otpVerifyHandler = async (event) =>{
    if(this.state.otp===''){
      this.setState({ otpErrorMsg: Helper.flashMsg('otpRequiredErr') });
    } else if(this.state.otpErrorMsg!==''){
      return;
    } else {
      const postData={
        otp: this.state.otp,
        email_id: this.state.email,
        client_id: "",
        client_type: "web",
        otp_session_id: this.state.otpSessionId,
        auth_type: "email"
      }
      this.loader.show(true);
      await this.props.otpVerifyResetPassAction(postData);
      if(this.props.otpVerifyData.status===200){
          this.setState({ otpSection: false, newPassSection: true });
      } else {
        this.loader.showAlert(true,'error',this.props.otpVerifyData.message)
      }
      this.loader.show(false);
    }
    
  }
  updatePasswordHandler = async (event) =>{
    console.log(this.state);
    if(!this.state.passFormValid){
      //this.loader.showAlert(true,'error',Helper.flashMsg('requireFields'))
      return;
    }
    const postData={
      email_id: this.state.email,
      password: this.state.new_password,
      client_id: "",
      client_type: "web",
      auth_type: "email"
    }
    this.loader.show(true);
    await this.props.resetPasswordAction(postData);
    if(this.props.otpVerifyData.status===200){
      //this.loader.showAlert(true,'success',Helper.flashMsg('signupSuccess'))
      this.onPressBackToLogin();
        console.log(this.props,'resetPasswordData');
    } else {
      this.loader.showAlert(true,'error',Helper.flashMsg('invalidParams'))
    }
    this.loader.show(false);
    //this.setState({ loginSection: false, emailSection: true });
  }

  onPressBackToLogin = () =>{
    this.setState({ loginSection: true, emailSection: false,  otpSection: false, newPassSection: false });
  }
  render() {
    const { loginSection, emailSection, otpSection, newPassSection, email } = this.state
    const formInputstyles = {
      position: 'absolute',
      left:0,
      top:0,
      transform: 'scale(0.8)',
      transformOrigin: 'left top',
      color: '#999',
      transition: 'all 0.3s',
      pointerEvents: 'none',
    }
    return (
    <Modal isOpen={this.props.state.isOpenLoginModal} aria-labelledby="ModalHeader">
        <ModalBody>
            <button type="button" className="close btn-close" data-dismiss="modal" aria-label="Close"  onClick={this.closeModal}>
              <span aria-hidden="true">×</span>
            </button>
            <div className="loginModalContainer">
              <div className="leftSide">
                <div className="inner">
                  <div className="inner-header">
                    <img alt="" src="images/logo/logo.png" className="logo" />
                  </div>
                  <div className="inner-body">
                    {/* Login Container Start*/}
                    { loginSection &&
                    <div className="loginContainer">
                      <p className="subTitle">
                        Welcome Back, Please login to your account.
                      </p>
                      <div className="socialBtns ">
                        <SocialBtns signupLoginBySocial={this.props.signupLoginBySocial}/>
                      </div>
                      <div className="dividerDiv">
                        <span>Or</span>
                      </div>
                      <div>
                        <div className="form-group">
                          <label className="hasPlaceholder">
                            <input type="text" name="login_email" onChange={this.props.onChnageHandler}/>
                            <span><span style={formInputstyles}>E-mail Address</span></span>
                            <span className="errorMsg">{this.props.state.loginFormErrors.email}</span>
                          </label>              
                        </div>
                        <div className="form-group">
                          <label className="hasPlaceholder">
                            <input type="password" name="login_password" onChange={this.props.onChnageHandler} />
                            <span><span style={formInputstyles}>Password</span></span>
                            <span className="errorMsg">{this.props.state.loginFormErrors.password}</span>
                          </label>             
                        </div>
                        <div className="d-flex align-items-center justify-content-between form-group">
                          <div>
                            {/* <label className="control control--checkbox">
                              <input type="checkbox" />
                              <div className="control__indicator" /> 
                              <span className="complete-false">Remember Me</span>
                            </label> */}
                          </div>
                          <div>
                            <Link to="#" id="forgotPasswordBtn" onClick={this.onPressForgotPass}>Forgot Password?</Link>
                          </div>
                        </div>
                        <div className="form-group">
                          <Link to="#" className="btn btn-danger" onClick={this.props.loginByEmail}>Login</Link>
                        </div>
                        <div style={{marginTop: '35px', fontSize: '12px'}}>
                          <span style={{color: '#999'}}>Not Registered? </span><Link to="#" className="link toSignupBtn" onClick={this.props.openModal.bind(this,'signUpModal')}>Create an account</Link>
                        </div>
                      </div>
                    </div>
                    }
                    {/* Login Container End*/}  
                    
                    {/* Reset Password Container Start: Enter Email*/}
                    {emailSection && 
                    <div className="forgotPasswordContainer">
                      <p className="subTitle">
                        Forgot Password?
                      </p>
                      <span style={{position: 'relative', top: '-12px'}}>We Just need your registered Email ID to send your password reset instructions</span>
                      <div>
                        <div className="form-group">
                          <label className="hasPlaceholder">
                            <input type="email" name="email" onChange={this.onChangeHandler}/>
                            <span><span style={formInputstyles}>Email Address</span></span>
                            <span className="errorMsg">{this.state.emailErrorMsg}</span>
                          </label>                                                 
                        </div>
                        <div className="form-group">
                          <Link to="#" className="btn btn-danger" id="sendMailBtn" onClick={this.sendOtpHandler}>Send</Link>
                        </div>
                        <div style={{marginTop: '15px', fontSize: '12px'}}>
                          <Link to="#" className="link toLoginBtn" onClick={this.onPressBackToLogin}>Back to Login</Link>
                        </div>
                      </div>
                    </div>
                    }
                    {/* Reset Password Container End: Enter Email*/}

                    {/* Reset Password Container Start: OTP*/}
                    { otpSection &&
                    <div className="otpContainer2">
                        <p className="subTitle">
                            Please type the verification code send to {email}
                        </p>
                        <div>
                            <div className="form-group">
                                <label className="hasPlaceholder">
                                    <input type="number" pattern="\d{6}" title='Only Number' min="0" step="1" name="otp" onChange={this.onChangeHandler}/>
                                    <span><span style={formInputstyles}>OTP Code</span></span>
                                    <span className="errorMsg">{this.state.otpErrorMsg}</span>
                                </label>                                                 
                            </div>
                            <div className="form-group">
                            <Link to="#" className="btn btn-danger" onClick={this.otpVerifyHandler}>Done</Link>
                            </div>
                            <div style={{marginop: "15px", fontSize: "12px"}}>
                              <Link to="#" className="link toLoginBtn" onClick={this.onPressBackToLogin}>Back to Login</Link>
                            </div>
                        </div>
                    </div>
                    }
                    {/* Reset Password Container End: OTP*/}

                    {/* Reset Password Container Start: Enter New Pasword*/}
                    { newPassSection &&
                    <div className="setPasswordContainer">
                      <p className="subTitle">
                        Reset Your Password
                      </p>
                      <div>
                        <div className="form-group">
                          <label className="hasPlaceholder">
                            <input type="password" name="new_password" onChange={this.onChangeHandler}/>
                            <span><span>Password</span></span>
                            <span className="errorMsg">{this.state.passFormErrors.new_password}</span>
                          </label>                                                 
                        </div>
                        <div className="form-group">
                          <label className="hasPlaceholder">
                            <input type="password" name="conf_password" onChange={this.onChangeHandler}/>
                            <span><span>Confirm Password</span></span>
                            <span className="errorMsg">{this.state.passFormErrors.conf_password}</span>
                          </label>                                                 
                        </div>
                        <div className="form-group">
                          <Link to="#" className="btn btn-danger" id="passwordSaveBtn" onClick={this.updatePasswordHandler}>Save</Link>
                        </div>
                        <div style={{marginTop: '15px', fontSize: '12px'}}>
                          <Link to="#" className="link toLoginBtn" onClick={this.onPressBackToLogin}>Back to Login</Link>
                        </div>
                      </div>
                    </div>
                    }
                    {/* Reset Password Container End: Enter New Pasword*/}


                    <div style={{marginTop: '35px'}}>
                      <span>You signing up you agree to Comrate's <Link to="/term-conditions" className="link">Terms and conditions</Link> &amp; <Link to="/term-conditions" className="link">Privacy Policy</Link></span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="rightSide">
                <style dangerouslySetInnerHTML={{__html: "\ncss-doodle {\n     --color: @p(#2eabee, #f66, #A8DADC, #457B9D, #1D3557);\n     /*--color: @p(#E63946, #F1FAEE, #A8DADC, #457B9D, #1D3557);*/\n     --position: @r(0%, 100%) @r(0%, 100%);\n\n     --pat-1: (\n         linear-gradient(var(--color), @lp())\n         var(--position) / @r(1px) @r(15%)\n         no-repeat\n         );\n\n     --pat-2: (\n         linear-gradient(\n         @pick(\n         -180deg, -135deg, -90deg, -45deg,\n         0deg, 45deg, 90deg, 135deg, 180deg \n         ),\n         var(--color) 50%, transparent 0)\n         var(--position) / @r(3%) @lr()\n         no-repeat\n         );\n\n     --pat-3: (\n         linear-gradient(var(--color), @lp())\n         var(--position) / @r(15%) 1px\n         no-repeat\n         );\n\n     --pat-4: (\n         radial-gradient(var(--color), @lp())\n         var(--position) / @r(5%) @lr()\n         no-repeat\n         );\n\n     --pat-5: (\n         radial-gradient(var(--color) 50%, transparent 0)\n         var(--position) / @r(5%) @lr()\n         no-repeat\n         );\n\n     --pat-6: (\n         conic-gradient(\n         from calc(145deg + @ri(4) * 90deg), \n         var(--color) 0,\n         @lp() 20%,\n         transparent 20%,\n         transparent 50%\n         )\n         var(--position) / @r(5%) @lr()\n         no-repeat\n         );\n\n     --pat-7: (\n         linear-gradient(\n         @p(45deg, -45deg),\n         transparent 0,\n         transparent calc(50% - .2px),\n         var(--color) calc(50% - .5px),\n         @lp() calc(50% + .5px),\n         transparent calc(50% + .2px)\n         )\n         var(--position) / @r(5%) @lr()\n         no-repeat\n         );\n\n     --rule: (\n         :doodle {\n         @grid: 1 / 100vmax;\n         position: absolute;\n     }\n     background-blend-mode: color-burn;\n     background:\n         @m(80, var(--pat-1)),\n         @m(80, var(--pat-2)),\n         @m(80, var(--pat-3)),\n         @m(80, var(--pat-4)),\n         @m(80, var(--pat-5)),\n         @m(80, var(--pat-6)),\n         @m(80, var(--pat-7));\n     );\n }\n                                " }} />
                <css-doodle use="var(--rule)" />
              </div>
            </div>

            <Loader onRef={ref => {this.loader = ref;}}/>
            </ModalBody>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  userData: state.auth.userData,
  tokenData: state.auth.tokenData,
  otpData: state.auth.otpData,
  otpVerifyData: state.auth.otpVerifyData,
});
function mapDispatchToProps(dispatch) {
  return {
    generateTokenAction: bindActionCreators(generateTokenAction, dispatch),
    sendOtpAction: bindActionCreators(sendOtpAction, dispatch),
    otpVerifyResetPassAction: bindActionCreators(otpVerifyResetPassAction, dispatch),
    resetPasswordAction: bindActionCreators(resetPasswordAction, dispatch),
  }
}
 
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAlert(LoginModal));
